/** Mirrors botifire/rbac.py PLATFORM_PERMISSIONS so the console hides actions a staff role can't perform
 *  (the API enforces the same rules server-side). */
const PLATFORM: Record<string, string[]> = {
  owner: ['platform.*'],
  operations: ['platform.read', 'platform.operations', 'platform.tenants', 'platform.support_access'],
  finance: ['platform.read', 'platform.billing'],
  support: ['platform.read', 'platform.tenants.read', 'platform.support_access'],
};

export function platformCan(role: string | undefined, perm: string): boolean {
  const perms = PLATFORM[role ?? ''] ?? [];
  return perms.includes('platform.*') || perms.includes(perm) || (perm.endsWith('.read') && perms.includes(perm.slice(0, -5)));
}
